import type { ApiMission, DrawEvent, Lead, Prize } from '../types';
import { getLang } from '../i18n';
import { getState } from './store';

export const leadById  = (id: string): Lead | undefined  => getState().leads.find(l => l.id === id);
export const prizeById = (id: string): Prize | undefined => getState().prizes.find(p => p.id === id);
export const missionById = (id: string | null): ApiMission | undefined => id ? getState().missions.find(m => m.id === id) : undefined;
export const eventById = (id: string | null): DrawEvent | undefined =>
  id ? getState().events.find(e => e.id === id) : undefined;

export const missionLabelOf = (m: ApiMission): string => (getLang() === 'pt' ? m.labelPt : m.labelEs) || m.labelEs;

export const eventPrizes = (eventId: string): Prize[] => getState().prizes.filter(p => p.eventId === eventId);

/** Soma dos prêmios ainda pendentes de um sorteio. */
export const pozoOf = (eventId: string): number =>
  eventPrizes(eventId).filter(p => p.status === 'pending').reduce((s, p) => s + (p.value || 0), 0);

export const pendingPrizes = (eventId: string): Prize[] => eventPrizes(eventId).filter(p => p.status === 'pending');
